import { assert_false, assert_hash_sha256_not_empty, assert_string_object_id_not_empty, not_implemented } from '@shared/asserts/utils_asserts';
import { DTO__database_entity } from '@shared/dto/_database_entity/DTO__database_entity';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DTO__image_asset } from '../../image_asset_base/DTO__image_asset';

export class DTO_IMAGE_META__base extends DTO__database_entity {
  /*
   * STATIC FIELDS
   */

  static _class_name_static: string = ENUM__dto_class_name.ABSTRACT;

  /*
   * FIELDS
   */
  private _image!: DTO__image_asset; //presence only on client

  workspace_id!: string;
  user_id_creator!: string;

  hash_sha256_content!: string;

  /*
   * PROPERTIES
   */

  set_image(value: DTO__image_asset) {
    if (value.is_stub() || this.hash_sha256_content == value.hash_sha256_content) {
      this._image = value.clone();
    }
  }

  get image() {
    return this._image;
  }

  get images_hashes() {
    let out = new Set<string>();

    out.add(this.hash_sha256_content);

    return out;
  }

  get image__is_initialized() {
    return !this.image.is_stub();
  }

  get images_hashes_to_load(): Set<string> {
    assert_false(this.is_stub());

    let out = new Set<string>();

    if (!this.image.is_stub()) return out; //already loaded

    //could be empty for copped image and masked+cropped
    if (!this.hash_sha256_content.is_empty_hash_sha256()) out.add(this.hash_sha256_content);

    return out;
  }

  get images__initialized_list() {
    let out = [];

    if (!this.image.is_stub()) out.push(this.image);
    return out;
  }

  /*
   * EVENTS
   */

  //key - hash_sha256_content
  on_images_loaded(images_map: Map<string, DTO__image_asset>) {
    if (!images_map.has(this.image.hash_sha256_content)) return;

    let image = images_map.get_or_assert(this.image.hash_sha256_content);

    this._image = image.clone();
  }

  /*
   * METHODS
   */
  constructor() {
    super();

    this._image = DTO__image_asset.CREATE_STUB();
  }

  //used on client
  images__try_load() {
    not_implemented();
  }

  //used on server
  async images__load_async() {
    not_implemented();
  }

  //used before sending via network
  images__stubify() {
    this.set_image(DTO__image_asset.CREATE_STUB());
  }

  //used before save to db
  images__delete() {
    delete (this as any).image;
  }

  assert_standard_fields(): void {
    super.assert_standard_fields();

    if (!this._id.is_empty_object_id()) {
      assert_hash_sha256_not_empty(this.hash_sha256_content);

      assert_string_object_id_not_empty(this.workspace_id);
      assert_string_object_id_not_empty(this.user_id_creator);
    }
  }
}
